/*
 * Model for Tenant Profile section
 */

define(["backbone", "messaging/messenger", "modules/shared/adminMenu/adminMenuModel"], function (
  Backbone,
  Messenger,
  AdminMenuModel,
) {
  var KbProfileModel = {};
  var menuItems;

  Messenger.reqres.setHandler("tenant:admin:menu:items", function () {
    if (!menuItems) {
      menuItems = new AdminMenuModel.menuItems([
        { name: "info", label: "admin.title.tenantTitle", default: true }, //selected by default
        { name: "apiKeys", label: "admin.title.apiKeysTitle" },
        { name: "departments", label: "admin.title.departmentsTitle" },
        { name: "roles", label: "admin.title.kbRolesTitle" },
        { name: "users", label: "admin.title.usersTitle" },
      ]);
    }
    return menuItems;
  });

  Messenger.reqres.setHandler("tenant:admin:menu:style", function () {
    return new AdminMenuModel.menuType({ type: "pills", stacked: true });
  });

  return KbProfileModel;
});
